document.fonts.ready.then(
  () => (document.querySelector("body")!.style.opacity = "1")
);
